import type { PopupTokens } from './types';

export const popup: PopupTokens = {
  radii: {
    default: 'big',
  },
};
